
let replace = false
export function hrefFix() {
  if(global.document && !replace){
    replace = true;
    const elem = document.querySelector('.footer__app-button')
    const hrefButton = elem?.href
    const dataHref = elem?.dataset.href

    if(hrefButton !== dataHref) {
      elem.href = dataHref
    }
  }
}
